// import React, { useState } from "react";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// import doctorService from "../../../Services/doctorService";

// const SectionLabel = ({ children }) => (
//   <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
//     {children}
//   </p>
// );

// const InputField = ({ label, endAdornment, ...props }) => (
//   <div className="flex flex-col gap-1">
//     <label className="text-[12px] font-[500] text-gray-500">{label}</label>
//     <div className="relative">
//       <input
//         {...props}
//         className={`w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100 ${
//           endAdornment ? "pr-10" : ""
//         }`}
//       />
//       {endAdornment && (
//         <div className="absolute right-3 top-1/2 -translate-y-1/2">
//           {endAdornment}
//         </div>
//       )}
//     </div>
//   </div>
// );

// const ValidatedField = ({ label, value, maxLength, onChange, placeholder, hint }) => {
//   const isComplete = value.length === maxLength;
//   const isPartial = value.length > 0 && value.length < maxLength;

//   return (
//     <div className="flex flex-col gap-1">
//       <div className="flex items-center justify-between gap-2 flex-wrap">
//         <label className="text-[12px] font-[500] text-gray-500">{label}</label>
//         {isPartial && (
//           <span className="text-[11px] text-red-400">
//             {maxLength - value.length} digits remaining
//           </span>
//         )}
//         {isComplete && (
//           <span className="text-[11px] text-green-500 font-[500]">
//             ✓ Valid {hint}
//           </span>
//         )}
//       </div>
//       <input
//         type="text"
//         value={value}
//         onChange={onChange}
//         maxLength={maxLength}
//         placeholder={placeholder}
//         className={`w-full px-3 py-2 text-[13px] bg-white border rounded-lg outline-none transition-colors
//           hover:border-orange-200 focus:ring-2 focus:ring-orange-100
//           ${
//             isComplete
//               ? "border-green-400 focus:border-green-400"
//               : isPartial
//               ? "border-red-300 focus:border-orange-200"
//               : "border-gray-200 focus:border-orange-200"
//           }`}
//       />
//     </div>
//   );
// };

// const AddEditDoctors = () => {
//   const [doctorData, setDoctorData] = useState({
//     name: "",
//     specialization: "",
//     phone_no: "",
//     cnic: "",
//     email: "",
//     qualification: "",
//     pay: 0,
//     experience: "",
//     commission: 0,
//     fee: 0,
//     pmdc_no: "",
//     password: "",
//     status: 1,
//   });

//   const [showPassword, setShowPassword] = useState(false);

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setDoctorData({ ...doctorData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await doctorService.update(id, doctorData);
//         toast.success("Doctor updated successfully!");
//       } else {
//         if (!doctorData.password) {
//           toast.error("Password is required for doctor portal access.");
//           return;
//         }
//         await doctorService.create(doctorData);
//         toast.success("Doctor added successfully!");
//       }
//       navigate("/doctor");
//     } catch (error) {
//       toast.error("Error saving Doctor.");
//     }
//   };

//   return (
//     <div className="bg-gray-50 flex justify-center py-6 sm:py-10 px-3 sm:px-4">
//       <div className="w-full max-w-7xl">
//         <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

//           {/* HEADER */}
//           <div className="bg-[#215187] px-5 sm:px-8 py-4 sm:py-5">
//             <h1 className="text-white text-[16px] sm:text-[18px] font-[500]">
//               {id ? "Edit Doctor" : "New Doctor Registration"}
//             </h1>
//             <p className="text-gray-300 text-[12px] mt-1">
//               {id ? "Update doctor's details below" : "Fill in the details to register a new doctor"}
//             </p>
//           </div>

//           {/* FORM */}
//           <form onSubmit={handleSubmit} className="px-4 sm:px-6 md:px-8 py-6">

//             <SectionLabel>Personal Information</SectionLabel>

//             {/* GRID 1 */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
//               <InputField
//                 label="Doctor Name"
//                 name="name"
//                 value={doctorData.name}
//                 onChange={handleChange}
//                 placeholder="Enter full name"
//                 required
//               />
//               <ValidatedField
//                 label="Phone Number"
//                 value={String(doctorData.phone_no)}
//                 maxLength={11}
//                 placeholder="03001234567"
//                 hint="number"
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/\D/g, "").slice(0, 11);
//                   setDoctorData({ ...doctorData, phone_no: val });
//                 }}
//               />
//               <ValidatedField
//                 label="CNIC"
//                 value={String(doctorData.cnic)}
//                 maxLength={13}
//                 placeholder="13 digit CNIC"
//                 hint="CNIC"
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/\D/g, "").slice(0, 13);
//                   setDoctorData({ ...doctorData, cnic: val });
//                 }}
//               />
//             </div>

//             {/* GRID 2 */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
//               <InputField
//                 label="Specialization"
//                 name="specialization"
//                 value={doctorData.specialization}
//                 onChange={handleChange}
//                 placeholder="Enter specialization"
//                 required
//               />
//               <InputField
//                 label="Qualification"
//                 name="qualification"
//                 value={doctorData.qualification}
//                 onChange={handleChange}
//                 placeholder="Enter qualification"
//                 required
//               />
//             </div>

//             {/* GRID 3 */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
//               <InputField
//                 label="Email"
//                 name="email"
//                 value={doctorData.email}
//                 onChange={handleChange}
//                 placeholder="Enter email"
//                 required
//               />
//               <InputField
//                 label={id ? "New Password (leave blank to keep current)" : "Password *"}
//                 name="password"
//                 type={showPassword ? "text" : "password"}
//                 value={doctorData.password}
//                 onChange={handleChange}
//                 placeholder="Enter portal password"
//                 endAdornment={
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="text-gray-400 hover:text-gray-600 transition-colors"
//                   >
//                     {showPassword ? <FiEyeOff className="w-4 h-4" /> : <FiEye className="w-4 h-4" />}
//                   </button>
//                 }
//               />

//             </div>

//             <SectionLabel>Professional Details</SectionLabel>

//             {/* GRID 4 */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
//               <InputField
//                 label="Commission"
//                 name="commission"
//                 type="number"
//                 value={doctorData.commission}
//                 onChange={handleChange}
//                 placeholder="Enter commission"
//               />
//               <InputField
//                 label="Doctor Fee"
//                 name="fee"
//                 type="number"
//                 value={doctorData.fee}
//                 onChange={handleChange}
//                 placeholder="Enter fee"
//               />
//               <InputField
//                 label="Experience (years)"
//                 name="experience"
//                 type="number"
//                 value={doctorData.experience}
//                 onChange={handleChange}
//                 placeholder="Enter experience"
//               />
//             </div>

//             {/* GRID 5 — PMDC  */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
//               <InputField
//                 label="PMDC No."
//                 name="pmdc_no"
//                 value={doctorData.pmdc_no}
//                 onChange={handleChange}
//                 placeholder="e.g. 3703-AJK"
//               />
//                 <InputField
//                 label="Pay"
//                 name="pay"
//                 type="number"
//                 value={doctorData.pay}
//                 onChange={handleChange}
//                 placeholder="Enter pay"
//                 required
//               />
//             </div>

//             {/* FOOTER */}
//             <div className="border-t mt-7 pt-5 flex flex-col-reverse sm:flex-row justify-between gap-3">
//               <button
//                 type="button"
//                 onClick={() => navigate(-1)}
//                 className="w-full sm:w-auto text-gray-500 hover:text-gray-700 text-[13px]"
//               >
//                 ← Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-6 py-2.5 rounded-lg"
//               >
//                 {id ? "Update Doctor" : "Save & Continue →"}
//               </button>
//             </div>

//           </form>
//         </div>

//         <p className="text-center text-[12px] text-gray-400 mt-4">
//           {id ? "Changes will be saved immediately." : "Doctor will be available after saving."}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default AddEditDoctors;
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import doctorService from "../../../Services/doctorService";

const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, endAdornment, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      <input
        {...props}
        className={`w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100 ${
          endAdornment ? "pr-10" : ""
        }`}
      />
      {endAdornment && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          {endAdornment}
        </div>
      )}
    </div>
  </div>
);

const ValidatedField = ({ label, value, maxLength, onChange, placeholder, hint }) => {
  const isComplete = value.length === maxLength;
  const isPartial = value.length > 0 && value.length < maxLength;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <label className="text-[12px] font-[500] text-gray-500">{label}</label>
        {isPartial && (
          <span className="text-[11px] text-red-400">
            {maxLength - value.length} digits remaining
          </span>
        )}
        {isComplete && (
          <span className="text-[11px] text-green-500 font-[500]">
            ✓ Valid {hint}
          </span>
        )}
      </div>
      <input
        type="text"
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        placeholder={placeholder}
        className={`w-full px-3 py-2 text-[13px] bg-white border rounded-lg outline-none transition-colors
          hover:border-orange-200 focus:ring-2 focus:ring-orange-100
          ${
            isComplete
              ? "border-green-400 focus:border-green-400"
              : isPartial
              ? "border-red-300 focus:border-orange-200"
              : "border-gray-200 focus:border-orange-200"
          }`}
      />
    </div>
  );
};

const AddEditDoctors = () => {
  const [doctorData, setDoctorData] = useState({
    name: "",
    specialization: "",
    phone_no: "",
    cnic: "",
    email: "",
    qualification: "",
    pay: 0,
    experience: "",
    commission: 0,
    fee: 0,
    pmdc_no: "",
    password: "",
    status: 1,
  });

  const [showPassword, setShowPassword] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDoctorData({ ...doctorData, [name]: value });
  };

  const [submitError, setSubmitError] = useState("");

  const isDuplicateError = (error) => {
    const msg = String(error?.message || error?.error || "").toLowerCase();
    return (
      error?.responseCode === 409 ||
      Number(error?.responseCode) === 409 ||
      msg.includes("duplicate") ||
      msg.includes("dup_entry") ||
      msg.includes("already registered")
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    try {
      if (id) {
        await doctorService.update(id, doctorData);
        toast.success("Doctor updated successfully!");
        navigate("/doctor");
      } else {
        if (!doctorData.password) {
          setSubmitError("Password is required for doctor portal access.");
          return;
        }
        await doctorService.create(doctorData);
        toast.success("Doctor added successfully!");
        navigate("/doctor");
      }
    } catch (error) {
      if (isDuplicateError(error)) {
        setSubmitError("This email is already registered to another doctor.");
      } else {
        setSubmitError("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className="bg-gray-50 flex justify-center py-6 sm:py-10 px-3 sm:px-4">
      <div className="w-full max-w-7xl">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* HEADER */}
          <div className="bg-[#215187] px-5 sm:px-8 py-4 sm:py-5">
            <h1 className="text-white text-[16px] sm:text-[18px] font-[500]">
              {id ? "Edit Doctor" : "New Doctor Registration"}
            </h1>
            <p className="text-gray-300 text-[12px] mt-1">
              {id ? "Update doctor's details below" : "Fill in the details to register a new doctor"}
            </p>
          </div>

          {/* FORM */}
          <form onSubmit={handleSubmit} className="px-4 sm:px-6 md:px-8 py-6">

            <SectionLabel>Personal Information</SectionLabel>

            {/* GRID 1 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              <InputField
                label="Doctor Name"
                name="name"
                value={doctorData.name}
                onChange={handleChange}
                placeholder="Enter full name"
                required
              />
              <ValidatedField
                label="Phone Number"
                value={String(doctorData.phone_no)}
                maxLength={11}
                placeholder="03001234567"
                hint="number"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 11);
                  setDoctorData({ ...doctorData, phone_no: val });
                }}
              />
              <ValidatedField
                label="CNIC"
                value={String(doctorData.cnic)}
                maxLength={13}
                placeholder="13 digit CNIC"
                hint="CNIC"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 13);
                  setDoctorData({ ...doctorData, cnic: val });
                }}
              />
            </div>

            {/* GRID 2 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
              <InputField
                label="Specialization"
                name="specialization"
                value={doctorData.specialization}
                onChange={handleChange}
                placeholder="Enter specialization"
                required
              />
              <InputField
                label="Qualification"
                name="qualification"
                value={doctorData.qualification}
                onChange={handleChange}
                placeholder="Enter qualification"
                required
              />
            </div>

            {/* GRID 3 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
              <InputField
                label="Email"
                name="email"
                value={doctorData.email}
                onChange={handleChange}
                placeholder="Enter email"
                required
              />
              <InputField
                label={id ? "New Password (leave blank to keep current)" : "Password *"}
                name="password"
                type={showPassword ? "text" : "password"}
                value={doctorData.password}
                onChange={handleChange}
                placeholder="Enter portal password"
                endAdornment={
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    {showPassword ? <FiEyeOff className="w-4 h-4" /> : <FiEye className="w-4 h-4" />}
                  </button>
                }
              />
            </div>

            <SectionLabel>Professional Details</SectionLabel>

            {/* GRID 4 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              <InputField
                label="Commission"
                name="commission"
                type="number"
                value={doctorData.commission}
                onChange={handleChange}
                placeholder="Enter commission"
              />
              <InputField
                label="Doctor Fee"
                name="fee"
                type="number"
                value={doctorData.fee}
                onChange={handleChange}
                placeholder="Enter fee"
              />
              <InputField
                label="Experience (years)"
                name="experience"
                type="number"
                value={doctorData.experience}
                onChange={handleChange}
                placeholder="Enter experience"
              />
            </div>

            {/* GRID 5 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-4">
              <InputField
                label="PMDC No."
                name="pmdc_no"
                value={doctorData.pmdc_no}
                onChange={handleChange}
                placeholder="e.g. 3703-AJK"
              />
              <InputField
                label="Pay"
                name="pay"
                type="number"
                value={doctorData.pay}
                onChange={handleChange}
                placeholder="Enter pay"
                required
              />
            </div>

            {/* ERROR BANNER */}
            {submitError && (
              <div className="mt-5 bg-red-50 border border-red-200 rounded-lg px-4 py-3 flex items-start gap-2">
                <span className="text-red-500 text-[15px] mt-[1px]">⚠</span>
                <p className="text-[13px] text-red-600 font-[500]">{submitError}</p>
              </div>
            )}

            {/* FOOTER */}
            <div className="border-t mt-7 pt-5 flex flex-col-reverse sm:flex-row justify-between gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto text-gray-500 hover:text-gray-700 text-[13px]"
              >
                ← Cancel
              </button>
              <button
                type="submit"
                className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-6 py-2.5 rounded-lg"
              >
                {id ? "Update Doctor" : "Save & Continue →"}
              </button>
            </div>

          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          {id ? "Changes will be saved immediately." : "Doctor will be available after saving."}
        </p>
      </div>
    </div>
  );
};

export default AddEditDoctors;